module.exports = __webpack_public_path__ + "static/media/A3.24fe3c2e.jpg";